import React from 'react';
import withIcon from '../utilities/withIcon';

const IconJumpToQuestionFilled = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm3.333 8.894-.082.071-2.001 2.011-2.001-2.01a.73.73 0 0 0-.953-.072l-.082.071a.738.738 0 0 0-.07.957l.07.083 2.519 2.53a.73.73 0 0 0 .952.07l.082-.07 2.519-2.53a.737.737 0 0 0 0-1.04.73.73 0 0 0-.953-.07zm-4.148-5.5a.73.73 0 0 0-.952.071l-2.519 2.53-.07.083a.738.738 0 0 0 .07.957l.082.07a.73.73 0 0 0 .953-.07l2-2.011 2.002 2.01.082.072a.73.73 0 0 0 .953-.071.737.737 0 0 0 0-1.04l-2.519-2.53z" />
    </g>
  );
};

export default withIcon(IconJumpToQuestionFilled);
